"use strict";
/*jshint esversion: 11 */

export default class PivotalApiEnvironments {
  static getLoginSuffix() {
    if (window?.drupalSettings?.csf_pivotal_env_suffix_login) {
      return window.drupalSettings.csf_pivotal_env_suffix_login;
    }

    return '';
  }

  static getMembreSuffix() {
    if (window?.drupalSettings?.csf_pivotal_env_suffix_membre) {
      return window.drupalSettings.csf_pivotal_env_suffix_membre;
    }

    return '_Membres';
  }

  static getBrokerSuffix() {
    if (window?.drupalSettings?.csf_pivotal_env_suffix_broker) {
      return window.drupalSettings.csf_pivotal_env_suffix_broker;
    }

    return '_Courtier';
  }

  static getFournisseurSuffix() {
    if (window?.drupalSettings?.csf_pivotal_env_suffix_fournisseur) {
      return window.drupalSettings.csf_pivotal_env_suffix_fournisseur;
    }

    return '_Espace_Partenaire';
  }

  static getEspaceMembreSuffix() {
    if (window?.drupalSettings?.csf_pivotal_env_suffix_espace_membre) {
      return window.drupalSettings.csf_pivotal_env_suffix_espace_membre;
    }

    return '_Espace_Membre';
  }
}
